import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { UserService } from '../../../../../../services/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { SchoolService } from '../../../../../../services/school.service';
import { ClassService } from '../../../../../../services/class.service';
import { UserStatus, UserType } from '../../../../../../model/Const';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CoursewareService } from '../../../../../../services/courseware.service';
import { TwNoticeService } from '../../../../../../services/tw-notice.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { NzDropdownMenuComponent } from 'ng-zorro-antd/dropdown';
import { OidPenPackagesService } from '../../../../../../services/oid-pen-packages.service';

@Component({
    selector: 'app-admin-resource-book-item-oid-package',
    templateUrl: './index.component.html',
    styleUrls: ['./index.component.scss'],
    standalone: false
})
export class AdminResourceBookItemOidPackageComponent implements OnInit {
  isAiLoading = false;
  isOCRLoading = false;
  user: any = null;
  constUserType = UserType;

  isLoading = false;
  form!: UntypedFormGroup;
  book_id = 0;
  currentPageIndex = 0;
  currentRegionIndex = 0;

  factory_pages: any[] = [];
  selectParagraphTextId = -1;


  pageConfig: any = [];
  oidPackageId = 0;
  bisType = 'book';



  @ViewChildren('affix') affixs!: ElementRef[];


  constructor(private userService: UserService,
              private clsService: ClassService,
              private schoolService: SchoolService,
              private coursewareService: CoursewareService,
              private oidPenPackagesService: OidPenPackagesService,
              private activatedRoute: ActivatedRoute ,
              private twNoticeService: TwNoticeService ,
              private cdRef: ChangeDetectorRef,
              private router: Router ,
              private fb: UntypedFormBuilder,
              private nzMessageService: NzMessageService) {
    this.user = this.userService.getUserInfo();

    this.activatedRoute.title.subscribe({
      next: (title) => {
      }
    });
    this.bisType = this.activatedRoute.pathFromRoot[2].snapshot.url[2].path;

    this.activatedRoute.params.subscribe( params => {
      console.log('params', params);
      this.book_id = +params['item_id'] || 0;
    });
  }

  ngOnInit() {
    if (this.book_id) {
      this.isLoading = true;
      this.coursewareService.fetch(this.bisType, this.book_id).then((result) => {
        console.log('coursewareService.fetch', result);
        this.factory_pages = result?.data.factory_pages;
        this.oidPenPackagesService.getPackageDetailByBook(this.book_id).then((result) => {
          console.log('getPackageDetailByBook.fetch', result);
          this.pageConfig = result.pageConfig || [];
          this.oidPackageId = +result.id;
        });
        this.isLoading = false;
      }).catch(err => {
        this.isLoading = false;
        this.nzMessageService.error(err.message || 'System Error');
      });
    }

  }

  pageIndexChange(index: number) {
    console.log('pageIndexChange', index);
    this.currentPageIndex = index;

    // const rect = this.factory_pages[this.currentPageIndex].image_area.images[0].hotzones[0].rect;

    const affix = this.affixs.find((_, i) => i === index );


    const pageImage = this.factory_pages[index].image_area.images[0];
    console.log('pageImage', pageImage);
    if (!pageImage.img_width || !pageImage.img_height) {
      this.isLoading = true;
      const img = new Image();
      img.onload = () => {
        console.log('img', img.width, img.height);
        pageImage.img_width = img.width;
        pageImage.img_height = img.height;
        // @ts-ignore
        // affix.ngAfterViewInit();
        this.isLoading = false;

      };
      img.src = pageImage.imageUrl;
    } else {
      // @ts-ignore
      // affix.ngAfterViewInit();
    }

    // setTimeout(() => {
    //   this.factory_pages[this.currentPageIndex].image_area.images[0].hotzones[0].rect = {...rect};
    // }, 1000);
  }


  saveCoursewareOidOPackage() {
    if (this.isLoading) {
      return;
    }



    const oidPackageData = {
      id: this.book_id,
      pageConfig: this.pageConfig
    };
    console.log('oidPackageData', oidPackageData);
    this.isLoading = true;
    this.oidPenPackagesService.updatePackage(this.oidPackageId, oidPackageData).then((result) => {
      this.isLoading = false;
      this.twNoticeService.success({nzContent: '儲存成功'});
      // const modal = this.twNoticeService.success({nzContent: '新增成功'})
      // modal.afterClose.subscribe(() => {
      //   this.router.navigate([`/admin/v3/resource/${this.bisType}/manage`]);
      // });
    }).catch(err => {
      this.isLoading = false;
      this.nzMessageService.error(err.message || 'System Error');
    });
  }



  getPicAspectRatio (page: any) {
    return page.image_area.images[0].img_width / page.image_area.images[0].img_height
  }

  addPageOidsField(pageIndex: number, $event: any) {
    $event?.preventDefault();
    if (!this.pageConfig[pageIndex]) {
      this.pageConfig[pageIndex] = [];
    }
    this.pageConfig[pageIndex].push(null);
  }
  removePageOidsField(pageIndex: number, oidIndex: number, $event: any) {
    $event?.preventDefault();
    console.log('removePageOidsField', {pageConfig: this.pageConfig, pageIndex, oidIndex});
    if (this.pageConfig[pageIndex] && this.pageConfig[pageIndex].length > 0 && oidIndex > -1) {
      this.pageConfig[pageIndex].splice(oidIndex, 1);
    }
  }



  // @ts-ignore
  protected readonly JSON = JSON;
}
